export default __webpack_public_path__ + "static/media/Girdle of Baleful Blood.a01948fa.jpg";